import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/lead-management/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/lead-management/FeaturesList";
import BookingCapture from "../components/lead-management/BookingCapture";
import Cta from "../components/lead-management/Cta";
import Testimonials from "../components/lead-management/Testimonials";

const LeadsManagement = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <BookingCapture />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default LeadsManagement;
